import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
const uuidSchema = z.string().uuid('Invalid UUID format');
export const StepSubmitParamSchema = z
    .object({
    sessionId: uuidSchema.openapi({
        description: 'Unique identifier of the study session',
        example: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    }),
    position: z
        .string()
        .transform((val) => parseInt(val, 10))
        .refine((val) => !isNaN(val) && val >= 0, 'Position must be a non-negative integer'),
})
    .openapi('StepSubmitParams');
export const StepSubmitBodySchema = z
    .object({
    responseJson: z.unknown().optional().openapi({
        description: 'The learner response payload (shape depends on question type). Omit for info steps.',
        example: { selected_option: 2 },
    }),
    responseType: z.string().optional().openapi({
        description: 'Optional response type identifier',
    }),
    responseTimeMs: z.number().int().nonnegative().optional().openapi({
        description: 'Time the learner spent on this step in milliseconds',
        example: 5200,
    }),
    clientSubmissionId: z.string().optional().openapi({
        description: 'Client-generated idempotency key for deduplication',
    }),
    deviceId: z.string().optional().openapi({
        description: 'Client device identifier',
    }),
    clientTs: z.string().optional().openapi({
        description: 'Client-side timestamp (ISO 8601)',
    }),
    confidence: z.number().min(0).max(1).optional().openapi({
        description: 'Post-answer confidence level (0-1). Only sent for confidence-check positions.',
        example: 0.5,
    }),
    readingMs: z.number().int().nonnegative().optional().openapi({
        description: 'Active time in the reading phase (before first interaction) in milliseconds',
        example: 3200,
    }),
    answeringMs: z.number().int().nonnegative().optional().openapi({
        description: 'Active time in the answering phase (first interaction to submit) in milliseconds',
        example: 8500,
    }),
    revisionCount: z.number().int().nonnegative().optional().openapi({
        description: 'Number of meaningful answer changes before submission',
        example: 2,
    }),
    initialResponseJson: z.unknown().optional().openapi({
        description: 'The first answer state committed by the learner (before any revisions)',
    }),
    focusLossCount: z.number().int().nonnegative().optional().openapi({
        description: 'Number of times the learner switched away from the tab during this step',
        example: 1,
    }),
    idleCount: z.number().int().nonnegative().optional().openapi({
        description: 'Number of times the idle timeout triggered during this step',
        example: 0,
    }),
    paasEffort: z
        .number()
        .int()
        .min(1)
        .max(9)
        .optional()
        .openapi({
        description: 'Paas mental-effort rating (1-9). Only sent when the placement assigned a Paas prompt to this step. Silently ignored if not assigned. See docs/fatigue-score/README.md §7.',
        example: 5,
    }),
})
    .optional()
    .default({})
    .openapi('StepSubmitBody');
//# sourceMappingURL=step-submit.schema.js.map